import { StatementCollectionModel, StatementLinesModel, StatementModel } from "@gerrieDev/Services/GerrieApiModels";
import { ApiParameter, get, HasPagingParameters } from "@insite/client-framework/Services/ApiService";

export interface GetStatementsApiParameter extends ApiParameter, HasPagingParameters {
    statementNumber?: string;
    poNumber?: string;
    search?: string;
    status?: string[];
    customerSequence?: string;
    fromDate?: string;
    toDate?: string;
    orderTotalOperator?: string;
    orderTotal?: number;
    productErpNumber?: string;
    sort?: string;
}

export interface GetStatementApiParameter extends ApiParameter {
    statementNumber?: string;
    additionalExpands?: string[];
    sTEmail?: string;
    sTPostalCode?: string;
}

export interface GetStatementLinesApiParameter extends ApiParameter, HasPagingParameters {
    statementNumber?: string;
    sort?: string;
}

const statementsUrl = "/api/v1/GerrieStatement";

const statementLinesUrl = "/api/v1/GerrieStatementLine";

export async function getStatements(parameter: GetStatementsApiParameter) {
    const statements = await get<StatementCollectionModel>(statementsUrl, parameter);
    statements.statements?.forEach(o => cleanStatement(o));
    return statements;
}

export async function getStatement(parameter: GetStatementApiParameter) {
    const statementNumber = parameter.statementNumber;
    const newParameter = { ...parameter };
    delete newParameter.statementNumber;
    const statement = await get<StatementModel>(`${statementsUrl}/${statementNumber}`, newParameter);
    cleanStatement(statement, parameter);
    return statement;
}

export async function getStatementLines(parameter: GetStatementLinesApiParameter) {
    const statementLines = await get<StatementLinesModel>(statementLinesUrl, parameter);
    return statementLines;
}

function cleanStatement(statement: StatementModel, parameter?: { expand?: string[]; additionalExpands?: string[] }) {
    statement.id = statement.statementNumber;
}